import { Component, OnInit, Inject, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
import moment from "moment-timezone";
import { BehaviorService } from "src/app/services/behaviour.service";
import { CommonService } from "src/app/services/common.service";
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: "app-age-verify",
  templateUrl: "./age-verify.component.html",
  styleUrls: ["./age-verify.component.css"],
})
export class AgeVerifyComponent implements OnInit {
  storeMobile: any;
  addressString = "";
  servicesOption: any = [];
  pickUpStoreList: any;
  pickupStoreListInThisRegion: any;
  loader: boolean = false;
  pickupAddress: any;
  auth: any;
  userId: any;
  userName: any;
  selectedStoreImage: any = "";
  storeId: any;
  storeName: any;
  storeAccountNum: any;
  authorization: any;
  latitude_new: number;
  longitude_new: number;
  selectedStoreAddress: string;
  siteDada: any = "";
  ageVerify: any;
  weekday: any = "";
  bgImage: any = "assets/images/bannerImg-desktopBanner.png";
  ageVerification= 'You must be at least 19 to enter';
  logoImage='assets/images/footerLogo-logo.png';
  selectedStoreName: any;
  pickopenHour;
  delOpenHour;
  
  private isBrowser: boolean;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private _bs: BehaviorService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    
    if (this.isBrowser) {
      let ageVerify: any = localStorage.getItem('ageVerify');
      if (ageVerify == true) {
        this.router.navigateByUrl('/');
      }
      let StoreId = localStorage.getItem("localStoreId");
      let storesLength: any = localStorage.getItem('stores');
      if (StoreId != null && ageVerify != null && storesLength == 1) {
        // this.router.navigateByUrl("/");
      }

      let refreshVar: any = this._bs.getSiteData().subscribe((res) => {
        if (res == true) {
          this.ngOnInit();
          this.loader = true;
          refreshVar.unsubscribe();
        } else {
          this.loader = false;
        }
      });
    }
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;

    this.weekday = new Date().toLocaleString("en-us", { weekday: "long" });
    this.ageVerify = localStorage.getItem("ageVerify");
    if (this.ageVerify == true || this.ageVerify == "true") {
      localStorage.setItem("ageVerify", "true");
      this.showModal('#SearchLocation');
    }   

    this.getStoreDetail();
    setTimeout(() => {
      let siteDada = JSON.parse(localStorage.getItem("siteData"));
      if (siteDada != null) {
        this.siteDada = siteDada;
        if (!this.siteDada?.footerLogo?.url.match('footerLogo-logo')) {          
          this.logoImage = this.siteDada?.footerLogo?.url;
        }
      }
    }, 1000);

    this.getData();
    if (this.siteDada != null) {
      this.selectedStoreName = localStorage.getItem("localStoreName");
      this.selectedStoreAddress = localStorage.getItem("addressString");
      localStorage.setItem("isSwitch", "false");
      this.getLogin();

      this.commonService.pickUpStore("").subscribe((res) => {
        this.pickUpStoreList = res;
        localStorage.setItem('stores', this.pickUpStoreList?.length);
        let weekday = new Date().toLocaleString("en-us", { weekday: "long" });

        if (this.storeDetails && this.storeDetails["StoreHours"] && this.storeDetails["DeliveryHours"][weekday]) {
          let a = this.storeDetails["StoreHours"][weekday];
          let dilveryHoursObj = this.storeDetails["DeliveryHours"][weekday];
          var currentTime = moment(new Date());
          var StoreOpenTime = a.Open.Hour + ":" + a.Open.Minute;
          var StoreCloseTime = a.Close.Hour + ":" + a.Close.Minute;
          var beginningTime = moment(StoreOpenTime, "HH:mm");
          var endTime = moment(StoreCloseTime, "HH:mm");
          if (currentTime > beginningTime && currentTime < endTime) {
            this.StoreClosed = false;
          } else {
            this.StoreClosed = true;
          }
          if (a) {
            this.dilverytime = dilveryHoursObj;
            localStorage.setItem("storeTiming", JSON.stringify(a));
          }
        }
      });
    }
  }

  private showModal(selector: string): void {
    if (this.isBrowser && typeof window !== 'undefined' && window['$']) {
      window['$'](selector).modal('show');
    }
  }

  private hideModal(selector: string): void {
    if (this.isBrowser && typeof window !== 'undefined' && window['$']) {
      window['$'](selector).modal('hide');
    }
  }

  getData() {
    this.commonService.Get("/websitesetup/ageverification").subscribe((res) => {
      if (res["meta"]["status"]) {
        if (res?.homePageContent != null) {
          if (res?.homePageContent?.ageVerification) {
            if (!res?.homePageContent?.ageVerification?.text?.match('You must be at least 19 to enter')) {
              this.ageVerification = res?.homePageContent?.ageVerification?.text;
            }
            if (!res?.homePageContent?.ageVerification?.bgImage.match('bannerImg-desktopBanner')) {
              this.bgImage = res?.homePageContent?.ageVerification?.bgImage;
            }
          }
        }
      }
    });
  }

  getLogin() {
    const formData = new FormData();
    formData.append("grant_type", "password");
    formData.append("username", "CannaLogic.COVA.APIUser.COVACafe");
    formData.append("password", "sevenstar@7#");
    formData.append("client_id", "COVACafe.CannaLogic");
    formData.append("client_secret", "iwH2N70bE23IHUD91f39WtO9");
    this.commonService.loginCredential(formData).subscribe((res) => {
      if (this.isBrowser) {
              localStorage.setItem("covatoken", res["access_token"]);

      }
    });
  }

  verifyAge(status) {
    if (!status) {
    } else {
    if (this.isBrowser) {
        localStorage.setItem("ageVerify", status);
      this.showModal('#SearchLocation');
    }
    }
  }

  closeParkPop() {
    this.hideModal('#parkvillePopUp');
  }

  updatePickUpStoreData(storeId, storeName, storeAccountNum, authorization, addressLine1, addressLine2, city, state, stateCode, country, countryCode, zip, addressObj, lat, long, statusCalled, list) {
    if (this.isBrowser) {
          localStorage.setItem("storeInfo", JSON.stringify(list));

    var pickupStatus = "false";
    if (statusCalled) {
      this.pickupAddress = list?.AddressLine2;
      pickupStatus = "false";
    }
    this.pickupAddress = list?.Address?.AddressLine2;
    localStorage.setItem("localStoreId", storeId);
    localStorage.setItem("storeCurrentAddress", this.pickupAddress);
    localStorage.setItem("addressString", this.pickupAddress);
    localStorage.setItem("addressForOrderPlace", addressLine2);
    localStorage.setItem("addressStatus", "true");
    localStorage.setItem("addressLatitude", lat);
    localStorage.setItem("addressLongitude", long);
    localStorage.setItem("postal_code", zip);
    localStorage.setItem("city", city);
    localStorage.setItem("state", state);
    localStorage.setItem("stateCode", stateCode);
    localStorage.setItem("country", country);
    localStorage.setItem("countryCode", countryCode);
    localStorage.setItem("dilveryStatus", "true");
    localStorage.setItem("localStoreName", storeName);
    localStorage.setItem("isPickUpOrder", pickupStatus);
    localStorage.setItem("storeAccountNum", storeAccountNum);
    localStorage.setItem("authorization", authorization);
 
    this.userId = localStorage.getItem("covaUserId");
    this.userName = localStorage.getItem("userName");
    let obj = {
      CustomerId: this.userId,
      AddressTypeId: 2,
      AttentionTo: this.userName,
      CountryCode: countryCode,
      Default: false,
      DoNotContact: true,
      Email: "",
      Locality: "",
      Notes: "",
      Phone: "",
      PostalCode: zip,
      PostOfficeBoxNumber: "",
      StateCode: stateCode,
      StreetAddress1: addressLine1,
      StreetAddress2: addressLine2,
      currentLat: lat,
      currentLong: long,
      formattedAddress: this.pickupAddress,
    };
    if (this.auth) {
      this.commonService.saveAddress(obj).subscribe((res) => {
        this._bs.routerData("reload-dash");

        this.hideModal('#SearchLocation');
        this.hideModal('#SearchLocation1');
        this.router.navigateByUrl("/");
      });
    } else {
      this._bs.routerData("reload-dash");

      this.hideModal('#SearchLocation');
      this.hideModal('#SearchLocation1');
      this.router.navigateByUrl("/");
    }
    }
  }

  popupOpen(mobile, Name, City, StateName, CountryCode, Zip, item?) {
    this.servicesOption = item?.services;
    this.storeMobile = mobile;
    this.selectedStoreAddress = item?.Address?.AddressLine1 + ", " + City + ", " + StateName + ", " + CountryCode + ", " + Zip;
    let weekday = new Date().toLocaleString("en-us", { weekday: "long" });

    if (item["StoreHours"] && item["StoreHours"][weekday]) {
      let a = item["StoreHours"][weekday];
      this.pickopenHour = a;
    }
    if (item["DeliveryHours"] && item["DeliveryHours"][weekday]) {
      this.delOpenHour = item["DeliveryHours"][weekday];
    }

    this.selectedStoreImage = item?.image;
    this.selectedStoreName = Name;

    this.showModal('#SearchLocation');
    this.showModal('#storeHistoryModal');
  }

  manageStoreTIme(type: any) {
    if (this.servicesOption.some((s) => s?.includes(type)) && type == "Delivery") {
      return true;
    }

    if (this.servicesOption.some((s) => s?.includes(type)) && type == "Pickup") {
      return true;
    }

    return;
  }

  manageOrderOption(type: any) {
    if (this.servicesOption.some((s) => s.includes(type)) && type == "Delivery") {
      return "Delivery ";
    }

    if (this.servicesOption.some((s) => s.includes(type)) && type == "Pickup") {
      return " Store  Pickup ";
    }

    if (this.servicesOption.some((s) => s.includes(type)) && type == "CurbsidePickup") {
      return " Curbside Pickup";
    }
    return;
  }

  modalClose() {
    this.hideModal('#storeHistoryModal');
    this.showModal('#SearchLocation');
  }

  popUpClose() {
    this.hideModal('#popup1information');
    this.showModal('#storeHistoryModal');
  }

  closePop() {
    this.hideModal('#worry_address_searchbar');
  }

  openModal(val) {
    if (val == 2) {
      this.hideModal('#parkvillePopUp');
      this.hideModal('#SearchLocation1');
      this.showModal('#SearchLocation');
    }
    if (val == 1) {
      this.hideModal('#worry_address_searchbar');
      this.hideModal('#SearchLocation');
      this.showModal('#SearchLocation1');
    }
    if (val == 0) {
      this.hideModal('#worry_address_searchbar');
      this.hideModal('#SearchLocation1'); //delivery
      this.showModal('#SearchLocation'); //map
    }
  }

  newStoreHoursFormat(hour, min) {
    if (hour != null && min != null) {
      var newFormatedValue = hour + ":" + min;
      return moment(newFormatedValue, ["HH:mm"]).format("h:mm A");
    }
  }

  selectMailOrderFromHeader(status) {
    this.hideModal('#herader_location_popup');
    this.hideModal('#storeHistoryModal');
    if (this.isBrowser) {
       if (localStorage.getItem("isPickUpOrder") == status) {
      if (status === "true") {
        this.showModal('#SearchLocation');
      } else {
        if (this.addressString == null) {
          this.addressString = "";
        }
        this.showModal('#SearchLocation1');
      }
    } else {
      localStorage.setItem("toChangeStatus", status);

      if (status === "true") {
        this.showModal('#SearchLocation');
      } else {
        if (this.addressString == null) {
          this.addressString = "";
        }
        this.showModal('#SearchLocation1');
      }
    }
    }
  }

  SelectedStoreName = "";
  storeOpenCloseTimeing(Name) {
    this.selectedStoreName = Name;
    this.hideModal('#storeHistoryModal');
    this.showModal('#storeOpenCloseTimeing');
  }

  dilverytime;
  storeDetails: any;
  StoreClosed;
  getStoreDetail() {
   if (this.isBrowser) {
    const obj = {
      Id: Number(localStorage.getItem("localStoreId")),
    };

    this.commonService.getStoreDetail(obj).subscribe((res) => {
      this.storeDetails = res["data"];
      let weekday = new Date().toLocaleString("en-us", { weekday: "long" });
      if (this.storeDetails && this.storeDetails["StoreHours"] && this.storeDetails["DeliveryHours"][weekday]) {
        let a = this.storeDetails["StoreHours"][weekday];
        let dilveryHoursObj = this.storeDetails["DeliveryHours"][weekday];
        var currentTime = moment(new Date());
        var StoreOpenTime = a.Open.Hour + ":" + a.Open.Minute;
        var StoreCloseTime = a.Close.Hour + ":" + a.Close.Minute;
        var endTime: any;
        var beginningTime = moment(StoreOpenTime, 'HH:mm');
        if (StoreCloseTime == '0:0') {
          StoreCloseTime = '24:0';
        }
        if (a.Close.Hour < a.Open.Hour && a.Close.Hour != '0') {
          endTime = moment(StoreCloseTime, 'HH:mm').add(1, 'day');
        } else {
          endTime = moment(StoreCloseTime, 'HH:mm');
        }
                 
        if (currentTime > beginningTime && currentTime < endTime) {
          this.StoreClosed = false;
        } else {
          this.StoreClosed = true;
        }
        if (a) {
          this.dilverytime = dilveryHoursObj;
          localStorage.setItem("storeTiming", JSON.stringify(a));
        }
      }
    }); 
   }
  }

  storeOpenCloseTimeing1() {
    this.hideModal('#storeOpenCloseTimeing');
    this.showModal('#storeHistoryModal');
  }
}